import { FETCH_LOCATIONS_SUCCEEDED, FETCH_LOCATION_BY_DESTINATION_ID_SUCCEEDED, MAP_DESTINATION_TO_LOCATION, PRE_FILL_LOCATION_COMPONENT_FILTER_FILTER } from './list.action';
import * as _ from 'lodash';
import { FETCH_ALL_DESTINATION_SUCCEEDED } from '../../destination/destination.action';

const Filters = (state = {}, action) => {
  switch (action.type) {
    case PRE_FILL_LOCATION_COMPONENT_FILTER_FILTER:
      delete state['destination_id'];
      delete state['location_id'];
      return _.assign(state, action.data);
    case FETCH_ALL_DESTINATION_SUCCEEDED:
      if (state['destination_id'] === undefined) {
        delete state['destination'];
      } else if (state['destination'] === undefined && action.com === 'SCAN_RACK_COMPONENT') {
        state['destination'] = _.find(action.data, item => item.getId() === state['destination_id']);
      }
      return state;
    default:
      return state;
  }
};

export const list = (state = { fetched: false, items: [], filters: {} }, action) => {
  switch (action.type) {
    case FETCH_LOCATIONS_SUCCEEDED:
      return _.assign(state, { fetched: true, items: action.data, pagination: action.pagination });

    case FETCH_LOCATION_BY_DESTINATION_ID_SUCCEEDED:
      return _.assign({}, state, { fetched: true, items: action.data });

    case MAP_DESTINATION_TO_LOCATION:
      return _.assign({}, state, {
        fetched: true,
        destinations: action.data,
        items: _.map(state.items, item => _.assign(item, { destination: _.find(action.data, i => i.getId() === item.destination_id) }))
      });
    case PRE_FILL_LOCATION_COMPONENT_FILTER_FILTER:
    case FETCH_ALL_DESTINATION_SUCCEEDED:
      return _.assign(state, {
        filters: Filters(state.filters, action)
      });
    default:
      return state;
  }
};
